module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    class: _vm.classes,
    on: {
      "mouseenter": _vm.handleMouseenter,
      "mouseleave": _vm.handleMouseleave
    }
  }, [_c('div', {
    ref: "reference",
    class: [_vm.prefixCls + '-submenu-title'],
    on: {
      "click": _vm.handleClick
    }
  }, [_vm._t("title"), _vm._v(" "), _c('Icon', {
    class: [_vm.prefixCls + '-submenu-title-icon'],
    attrs: {
      "type": "ios-arrow-down"
    }
  })], 2), _vm._v(" "), (_vm.mode === 'vertical') ? _c('collapse-transition', [_c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.opened),
      expression: "opened"
    }],
    class: [_vm.prefixCls]
  }, [_vm._t("default")], 2)]) : _c('transition', {
    attrs: {
      "name": "slide-up"
    }
  }, [_c('Drop', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.opened),
      expression: "opened"
    }],
    ref: "drop",
    style: (_vm.dropStyle),
    attrs: {
      "placement": "bottom"
    }
  }, [_vm._t("default")], 2)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-798280ba"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/iview/src/components/menu/submenu.vue
// module id = 653
// module chunks = 1